import { Option } from 'components/formComponents/Base/Dropdown';
import { BisnodeWorksite } from '../../../types/Bisnode/BisnodeWorksite';

export const getWorksiteAlternative = (worksite: BisnodeWorksite): Option => {
  const visiting = worksite.visitingAddress;
  const postal = worksite.postalAddress;

  const city = worksite.visitingAddress
    ? worksite.visitingAddress.city
    : worksite.postalAddress
      ? worksite.postalAddress.city
      : '';

  const address = visiting?.address || postal?.address;

  const subLabel = address
    ? `${address}, ${worksite.visitingAddress.city}`
    : city;

  return {
    value: worksite.id,
    label: worksite.name,
    subLabel,
  };
};
